import React from 'react';
import More from '../../components/about/more'

function about() {
  return (
    <>
        <More />
    </>
  )
}

export default about